import styled from 'styled-components';

export const SubscriptionRowStyled = styled.div`
  font-weight: 600;
  font-size: 18px;
  line-height: 20px;
  color: #c1c1c1;
  text-align: center;
  transition: color 0.2s;
  cursor: pointer;

  &.active {
    color: #1d201f;
  }

  &.with-border {
    border-bottom: 1px solid #eeeeee;
  }

  &.month {
    order: 0;
    padding: 20px 0 24px 0;
  }

  &.discount {
    order: 1;
    padding: 9px 0 11px 0;
  }

  &.price {
    order: 2;
    padding-top: 15px;
  }

  & .row-desc {
    font-weight: 400;
    font-size: 14px;
    line-height: 16px;
    text-align: center;
    color: #1d201f;
    opacity: 0;
    margin-bottom: 13px;
    transition: opacity 0.2s;
  }

  &.active .row-desc {
    opacity: 1;
  }

  & .total-price {
    font-weight: 600;
    font-size: 12px;
    line-height: 20px;
    text-align: center;
    text-decoration: line-through;
  }
`;
